(function () {
  'use strict';

  /* ── Scroll Reveal ── */
  function tagElements() {
    var sel = ['.card-wrapper','.product-item','.grid__item','.shopify-section h2','.shopify-section h3','.banner__content','.banner__box','.footer-block'].join(',');
    document.querySelectorAll(sel).forEach(function(el) {
      if (!el.classList.contains('ali-reveal')) el.classList.add('ali-reveal');
    });
  }
  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.classList.add('ali-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.ali-reveal').forEach(function(el) { io.observe(el); });
  }

  /* ── Nav Scroll ── */
  function initNav() {
    var h = document.querySelector('header.header, sticky-header, .header-wrapper');
    if (!h) return;
    window.addEventListener('scroll', function() {
      h.style.backgroundColor = window.pageYOffset > 50 ? 'rgba(8,10,14,0.99)' : 'rgba(8,10,14,0.96)';
    }, { passive: true });
  }

  /* ── Card Hover Glow ── */
  function initCards() {
    document.querySelectorAll('.card-wrapper').forEach(function(w) {
      var c = w.querySelector('.card');
      if (!c) return;
      w.addEventListener('mouseenter', function() { c.style.borderColor = 'rgba(255,255,255,0.15)'; });
      w.addEventListener('mouseleave', function() { c.style.borderColor = 'rgba(255,255,255,0.07)'; });
    });
  }

  /* ── Auto-load deferred product media ── */
  function initDeferredMedia() {
    if (!document.querySelector('media-gallery, .product__media-wrapper')) return;
    function loadAll() {
      document.querySelectorAll('deferred-media').forEach(function(el) {
        if (el.getAttribute('loaded')) return;
        // Use Horizon's native loadContent method if present
        if (typeof el.loadContent === 'function') {
          el.loadContent(false);
          return;
        }
        // Fallback: manually move template content into DOM
        var tpl = el.querySelector('template');
        if (tpl) {
          el.appendChild(document.importNode(tpl.content, true));
          el.setAttribute('loaded', 'true');
        }
      });
    }
    // Run after a short delay to let Horizon's own JS initialise first
    setTimeout(loadAll, 400);
  }

  /* ── Boot ── */
  function init() {
    tagElements();
    initReveal();
    initNav();
    initCards();
    initDeferredMedia();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function() {
    tagElements(); initReveal(); initCards(); initDeferredMedia();
  });
}());
